class AppStorage {
    constructor(timeOffset) {
        this.timeOffset = timeOffset;
        this.store = [];
        this.length = 0;
        this.type = "internal";
        if (this.checkEngine(localStorage)) {
            this.engine = localStorage
            this.type = "localStorage";
        } else {
            if (this.checkEngine(sessionStorage)) {
                this.engine = sessionStorage
                this.type = "sessionStorage";
            } else {
                this.engine = this;
            }
        }
    }

    get(key) {
        return this.engine.getItem(key);
    }

    set(key, value) {
        try {
            this.engine.setItem(key, value);
        } catch (err) {
            this.clean();
            this.engine.setItem(key, value);
        }
    }

    remove(key) {
        this.engine.removeItem(key);
    }

    getTime() {
        return (new Date()).getTime() - this.timeOffset;
    }

    clean() {
        if (this.engine.length) {
            for (let key in this.engine) {
                if (typeof key === "string" && key !== "length") {
                    let remove = true;
                    if (key.indexOf("GameSize:") === 0) {
                        remove = false;
                    }
                    if (key.indexOf("chat:hide:") > 0) {
                        if (this.engine[key] === "true" && key.indexOf("hidden_") !== 0) {
                            remove = false;
                        }
                    }
                    if (key.indexOf(":chatSettings") > 0) {
                        remove = false;
                    }
                    if (key.indexOf("mute:") === 0) {
                        if (parseInt(this.get(key)) > this.getTime()) {
                            remove = false;
                        }
                    }
                    if (remove) {
                        this.engine.removeItem(key);
                    }
                }
            }
        }
        if (document.cookie.length) {
            for (let key in this.engine) {
                if (typeof key === "string" && key !== "length") {
                    let remove = true;
                    if (key.indexOf("GameSize:") === 0) {
                        remove = false;
                    }
                    if (key.indexOf("chat:hide:") > 0) {
                        if (this.engine[key] === "true" && key.indexOf("hidden_") !== 0) {
                            remove = false;
                        }
                    }
                    if (key.indexOf(":chatSettings") > 0) {
                        remove = false;
                    }
                    if (key.indexOf("mute:") === 0) {
                        if (parseInt(this.get(key)) > this.getTime()) {
                            remove = false;
                        }
                    }
                    if (remove) {
                        this.engine.removeItem(key);
                    }
                }
            }
        }
    }

    cleanByPrefix(prefix) {
        if (this.engine.length) {
            for (let key in this.engine) {
                if (typeof key === "string") {
                    if (key.indexOf(prefix) === 0) {
                        this.engine.removeItem(key);
                    }
                }
            }
        }
    }

    getItem(key) {
        if (typeof this.store[key] !== undefined) {
            return this.store[key];
        }

        return null;
    }

    setItem(key, value) {
        this.store[key] = value;
        this.store.length++;
    }

    removeItem(key) {
        if (typeof this.store[key] !== "undefined") {
            delete this.store[key];
            this.store.length--;
        }
    }

    status() {
        return {type: this.type, count: this.engine.length ? this.engine.length : this.store.length, mem: this.getMemSize(this.engine.length ? this.engine : this.store)}
    }

    getMemSize(object) {
        let objectList = [];
        const stack = [object];
        let bytes = 0;

        while (stack.length) {
            const value = stack.pop();
            if (typeof value === 'boolean') {
                bytes += 4;
            } else if (typeof value === 'string') {
                bytes += value.length * 2;
            } else if (typeof value === 'number') {
                bytes += 8;
            } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
                objectList.push(value);
                for (const i in value) {
                    stack.push(value[i]);
                }
            }
        }
        if (bytes) {
            return bytes / 1000000;
        } else {
            return 0;
        }
    }

    checkEngine(engine) {
        try {
            if (typeof engine === "object") {
                engine.setItem("test", "1");
                if (engine.getItem("test") === "1") {
                    engine.removeItem("test");
                    return true;
                }
            }
        } catch (e) {
            return false;
        }
        return false;
    }
}